import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { CheckObjectEditor } from "../objectEditors";
import { AbstractFormatObjectAlert, RegisterableAlert } from "../alerts";

export class CheckObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: AbstractFormatObjectAlert[] = [];
    if (object instanceof CheckObjectEditor) {
      if (!object.categoryName().getValue()) {
        alerts.push(new RegisterableAlert(object, "分類名が未設定です。"));
      }
    }
    return alerts;
  }
}
